import React,{ useState,useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {connect} from 'react-redux';
import swal from 'sweetalert';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from "mui-datatables";
import {API_URL} from '../../config.json';
import axios from 'axios';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';


import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import {pathSpliter,authInfo} from '../../lib/functions'

import {currentRouteSet} from '../../actions/actions';


const UnitManage = ({location,currentRouteSet,currentRoute,authInfo})=>{
    const classes = useStyles();
 
  useEffect(()=>{
    getUnits();
    getBaseUnits()
    currentRouteSet(pathSpliter(location.pathname,1));
    
  },[])

    // Init states start
 
    let [units,unitsSet] = useState([]);
    let [baseUnits,baseUnitsSet] = useState([]);
    let [selectedBaseUnit,selectedBaseUnitSet] = useState(null);
    
    let [loadingList,loadingListSet] = useState(false)
    let [loadingSave,loadingSaveSet] = useState(false)

    let [action,action_set] = useState('create');
    let [unit_id,unit_id_set] = useState(0);
    let [unit_name,unit_name_set] = useState('');
    let [unit_symbol,unit_symbol_set] = useState('');
    let [is_multi_unit,is_multi_unit_set] = useState('no');
    let [conversion,conversion_set] = useState(1);

    const unit_name_ref = useState(null)
    const unit_symbol_ref = useState(null)
    
    


    // Init states end
    // Methods script start
    const saveFormAction = async ()=>{
          if(unit_name.trim() == ''){
            swal({
              title:'Unit Name is Required.',
              icon:'warning'
            })
          }else if(unit_symbol.trim() == ''){
            swal({
              title:'Unit Symbol is Required.',
              icon:'warning'
            })
          }else if(is_multi_unit == 'yes' && selectedBaseUnit == null){
            swal({
              title:'Select a Base Unit',
              icon:'warning'
            })
          }else{
            loadingSaveSet(true);
            await axios.post(`${API_URL}/api/save-unit-manage`,{
              unit_name:unit_name.trim(),
              unit_symbol:unit_symbol.trim(),
              is_multi_unit,
              conversion,
              base_unit_id : selectedBaseUnit != null ? selectedBaseUnit.unit_id : 0,
              action,
              unit_id
            },{headers:{'auth-token': authInfo.token}}).then(res=>{
              loadingSaveSet(false);
              getUnits()
              getBaseUnits()
              if(res.data.error){
                swal({
                  title: res.data.msg,
                  icon:'warning'
                })
              }else{
                swal({
                  title: res.data.msg,
                  icon:'success'
                })

                unit_id_set(0)
                unit_name_set('')
                unit_symbol_set('')
                is_multi_unit_set('no')
                conversion_set(1)
                selectedBaseUnitSet(null)
                action_set('create')


              }
              
            });
          }
          
    }


    useEffect(()=>{
      if(is_multi_unit == 'yes'){
        let text = selectedBaseUnit != null ? selectedBaseUnit.unit_name : ' unit '
        unit_name_set(unit_symbol + ' of ' + conversion + ' ' + text)
      }else{
        conversion_set(1)
        selectedBaseUnitSet(null)
        unit_name_set(unit_symbol)
      }
    },[is_multi_unit,unit_symbol,conversion,selectedBaseUnit])
 


  
    const getUnits = async ()=>{
      await axios.post(`${API_URL}/api/get-item-units`,{'type':'base_unit'},{headers:{'auth-token':authInfo.token}}).then(res=>{
        baseUnitsSet(res.data)
      })
    }
    const getBaseUnits = async ()=>{
      await axios.post(`${API_URL}/api/get-item-units`,{'type':'all'},{headers:{'auth-token':authInfo.token}}).then(res=>{
        unitsSet(res.data)
      })
    }
   


    // Methods script end
    const ActionOptions = (props)=>{
      return(<div style={{textAlign:'right'}}> 

{
    authInfo.role !='user'?(
    <>
        <EditIcon style={{cursor:'pointer',fontSize: '28px',color: 'rgb(15, 126, 119)'}} onClick={()=>unitEdit(props.rowData)}/>
      
        <DeleteIcon style={{cursor:'pointer',color: '#ff0202',fontSize: '28px'}} onClick={()=>unitDelete(props.rowData)}/>
            
   </>):''
 }
      
      </div>)
    
    }


    const unitEdit = (row,index)=>{
      let unit =  units.filter((unit)=>unit.unit_id == row[0])
      unit_id_set(unit[0].unit_id)
      unit_name_set(unit[0].unit_name)
      unit_symbol_set(unit[0].unit_symbol)
      is_multi_unit_set(unit[0].is_multi_unit)
      conversion_set(unit[0].conversion)
      selectedBaseUnitSet({unit_name: unit[0].base_unit_name,unit_id: unit[0].base_unit_id})
      action_set('update')
      

    }


    const unitDelete = async (row)=>{
      swal({
        title:'Are you sure delete this?',
        icon:'warning',
        buttons:true
      }).then(async(yes)=>{
        if(yes){
          let unit =  units.filter((unit)=>unit.unit_id == row[0])
          await axios.post(`${API_URL}/api/delete-item-unit`,{unit_id:unit[0].unit_id},
          {headers:{'auth-token':authInfo.token}}).then(res=>{
                  getUnits();
                  getBaseUnits();
                  swal({
                    title: res.data.msg,
                    icon:'success'
                  })
                  
                })
        }else{
          return false
        }
      })
      

          }
   
    const columns = [
      {name: "unit_id",options: { display: 'excluded' }},
      {name:"SL",options: {filter: false,sort: false,
        customBodyRender:(value,tableMeta)=>{
        return ( <>{parseFloat(tableMeta.rowIndex)+1}</> ); 
      }
      },headerStyle: {
        textAlign:'left'
      }},
      {name: "unit_name",label: "Unit Name",options: {filter: true,sort: true}},
      {name: "unit_symbol",label: "Unit Symbol",options: {filter: true,sort: true}},
      {name: "is_multi_unit",label: "Miltiple Unit",options: {filter: true,sort: true}},
      {name: "conversion",label: "Conversion",options: {filter: true,sort: true}},
      {name: "base_unit_name",label: "Base Unit Name",options: {filter: true,sort: true}},
      
      {name:"actions",options: {filter: false,sort: false,
        customBodyRender:(value,tableMeta)=>{
          return ( <ActionOptions   value={value} rowIndex={tableMeta.rowIndex}  rowData={tableMeta.rowData} 
             /> ); 
      }
      },headerStyle: {
        textAlign:'right'
      }}
     ];
            
     const options = {
       filterType: 'checkbox',
       selectableRows: 'none',
       display: "excluded"
      }




    return (
    <div className={classes.root}>

     <Paper className={classes.paper} style={{marginTop:'-15px'}}>
    <h2 className={classes.pageEntryLabel}>Item Unit Entry & Measurement </h2>
      <Grid container spacing={2}>
      
        <Grid item xs={12} sm={3}> 
        <TextField  autoComplete='off' className={classes.fullWidth} 
        label="Unit Name" name="unit_name" 
        inputRef={unit_name_ref}
        onKeyDown={event => {
          if (event.key === "Enter") {
            unit_symbol_ref.current.focus()
          }
        }}
        value={unit_name} disabled={is_multi_unit=='yes'?true:false} variant="outlined" size="small" onChange={(e)=>unit_name_set(e.target.value)} />
        </Grid>

        <Grid item xs={12} sm={3}> 
        <TextField  autoComplete='off' 
         inputRef={unit_symbol_ref}
        
          className={classes.fullWidth} 
        label="Unit Symbol" name="unit_symbol" value={unit_symbol} variant="outlined" size="small" onChange={(e)=>unit_symbol_set(e.target.value)} />
        </Grid>


        <Grid item xs={12} sm={2}>
              <input type="checkbox" 
              disabled={action=='update'?true:false}
               id="is_multi_unit" checked={is_multi_unit=='yes'?true:false} name="is_multi_unit" 
                onChange={(e)=>is_multi_unit_set(e.target.checked?'yes':'no')}
              />
              <label for="is_multi_unit">Is Multiple Unit ?</label>
              {
                is_multi_unit == 'yes' ? (<>
                    <p>Master Unit :  <br/><b> {unit_name}</b></p>
                </>):''
              }
        </Grid>



        {
          is_multi_unit == 'yes'?(
            <>
                 

        

        <Grid item xs={12} sm={2}> 
        <TextField type="number" disabled={action=='update'?true:false}  autoComplete='off' className={classes.fullWidth} 
        label="Conversion" name="conversion" value={conversion} variant="outlined" size="small" onChange={(e)=>{
          if(e.target.value < 1){
            conversion_set(1)
          }else{
            conversion_set(e.target.value)
          }
        }} />
        </Grid>

        <Grid item xs={12} sm={2}> 
              <Autocomplete
              disabled={action=='update'?true:false}
              autoHighlight={true}
              openOnFocus={true}
              style={{ width: '100%' }}
              options={baseUnits} 
              size="small"
              classes={{
                option: classes.option,
              }}
              getOptionLabel={(option) => option.unit_name}
              value={selectedBaseUnit}
              onChange={(event,selectedObj)=>{
                  selectedBaseUnitSet(selectedObj)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose a Base Unit"
                  variant="outlined"
                
                />
              )}
          />
        </Grid>
            </>
          ):''
        }

       

           
  
  </Grid>


  
         <Grid item xs={12}>
  <Button style={{marginTop: '25px'}}
        variant="contained"
        color="primary"
        size="small"
        className={classes.button}
        disabled={loadingSave}
        startIcon={<SaveIcon />}
        onClick={saveFormAction}
      >
        Save
      </Button>
  </Grid>         


     </Paper>

     {
      loadingList==true?(<b>Loading...</b>):(
        <Paper className={classes.paper} style={{marginTop:'20px'}}>
        <MUIDataTable
      title={"Item Unit List"}
      data={units}
      columns={columns}
      options={options}
      adjustForCheckbox={false} 
      displaySelectAll={false}
      />
      </Paper>
      )
      
     }

     
    </div>
        
    );
}


 const options = {
   filterType: 'checkbox',
 };
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },

root: {},
'& .MuiTextField-root': {
  margin: theme.spacing(1),
  width: '25ch',
 },
  paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
  },
  pageEntryLabel:{
      color: '#7754cc',
      margin: '0px',
      padding: '0px',
      marginTop: '-11px',
      textAlign: 'left',
      marginLeft: '0px',
      marginBottom: '5px'
  },
  fullWidth:{
      width:'100%'
  },
  option: {
      fontSize: 15,
      '& > span': {
        marginRight: 10,
        fontSize: 18,
      },
    }
}));

const mapStateToPops = (state)=>{
      return {
        currentRoute:state.currentRouteReducer,
        authInfo:state.authInfoReducer
      }
}
export default connect(mapStateToPops,{currentRouteSet})(UnitManage);